export const getMinDate = (date: Date): Date => {
  if (!date) return new Date();
  const newDate = new Date(date);
  return new Date(newDate.setDate(newDate.getDate() + 1));
};
